import { motion, Variants } from "framer-motion"
import { User, MapPin, ArrowRight, Star } from "lucide-react"
import { NetworkMembroItem } from "@/types/membros"
import { imagebossCover } from "@/utils/imageboss"

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 15 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.215, 0.61, 0.355, 1] } },
}

interface MemberCardProps {
  membro: NetworkMembroItem
  onClick: (id: string) => void
  isFavorite?: boolean
}

export const MemberCard = ({ membro, onClick, isFavorite }: MemberCardProps) => (
  <motion.div
    variants={itemVariants}
    onClick={() => onClick(membro.pesUid)}
    className="group flex cursor-pointer items-center gap-4 rounded-2xl border border-zinc-800 bg-zinc-900/40 p-4 transition-colors hover:bg-zinc-800/80 active:scale-[0.98]"
  >
    <div className="relative size-16 flex-shrink-0 overflow-hidden rounded-xl border border-zinc-800 bg-black">
      {membro.pesFotoUrl ? (
        <img
          src={imagebossCover(membro.pesFotoUrl, 128, 128, "face") ?? membro.pesFotoUrl}
          alt={membro.pesNome}
          className="h-full w-full object-cover object-top"
          loading="lazy"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center text-zinc-800">
          <User size={24} />
        </div>
      )}
      {isFavorite && (
        <div className="absolute -right-0.5 -top-0.5 flex size-5 items-center justify-center rounded-bl-lg bg-zinc-900/80">
          <Star
            size={12}
            className="fill-yellow-500 text-yellow-500"
          />
        </div>
      )}
    </div>

    <div className="min-w-0 flex-1">
      <h3 className="truncate text-sm font-bold text-zinc-100 transition-colors group-hover:text-primary">
        {membro.pesNome}
      </h3>
      <p className="truncate text-[11px] font-medium text-zinc-500">{membro.empFantasia}</p>
      {(membro.empCidade || membro.empEstado) && (
        <div className="mt-2 flex items-center gap-1 text-[9px] font-bold uppercase tracking-wider text-zinc-600">
          <MapPin
            size={9}
            className="text-primary/40"
          />
          <span>
            {membro.empCidade} / {membro.empEstado}
          </span>
        </div>
      )}
    </div>
    <ArrowRight
      size={14}
      className="-translate-x-2 text-primary opacity-0 transition-all group-hover:translate-x-0 group-hover:opacity-100"
    />
  </motion.div>
)
